export const messages = {
  en: {
    workflowManage: {
      search: {
        title: 'Search Conditions',
        flowId: 'Please enter workflow code',
        flowName: 'Please enter workflow name',
        flowType: 'Please select workflow type'
      },
      list: {
        title: 'Workflow Information'
      },
      table: {
        flowId: 'Workflow Code',
        flowName: 'Workflow Name',
        flowType: 'Workflow Type',
        createTime: 'Create Time'
      },
      operation: {
        setting: 'Setting',
        viewImage: 'Flow Chart'
      },
      fetchError: 'Failed to fetch workflow data',
      imageError: 'Failed to load workflow image'
    }
  },
  zh: {
    workflowManage: {
      search: {
        title: '查询条件',
        flowId: '请输入流程编码',
        flowName: '请输入流程名称',
        flowType: '请选择流程类型'
      },
      list: {
        title: '流程信息'
      },
      table: {
        flowId: '流程编码',
        flowName: '流程名称',
        flowType: '流程类型',
        createTime: '创建时间'
      },
      operation: {
        setting: '设置流程',
        viewImage: '流程图'
      },
      fetchError: '获取流程数据失败',
      imageError: '加载流程图失败'
    }
  }
}